<template>
  <div>
    <md-table
      :value="data.length == 0 ? [] : data"
      class="paginated-table challenge-results"
    >
      <md-table-toolbar>
        <md-field class="pagination">
          <label for="pages">Pro Seite</label>
          <md-select
            v-model="paginationPerPage"
            name="pages"
          >
            <md-option
              v-for="item in perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            >
              {{ item }}
            </md-option>
          </md-select>
        </md-field>

        <md-field class="search">
          <md-input
            v-model="searchQuery"
            type="search"
            class="mb-3"
            clearable
            style="width: 200px"
            placeholder="Suche"
          />
          <md-icon>search</md-icon>
        </md-field>
      </md-table-toolbar>

      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }"
      >
        <md-table-cell
          class="test-id"
          md-label="Platz"
          md-sort-by="result.rank"
          md-numeric
          style="width: 10%"
        >
          <span>
            {{ item.result.rank || "-" }}
            <img
              v-if="displayCrown && item.result.rank <= 3"
              style="width: 20px !important;"
              :src="getCrownImage(item.result.rank)"
            >
          </span>
        </md-table-cell>

        <md-table-cell
          md-label="Name"
          md-sort-by="data.nachname"
          style="width: 35%"
        >
          <user-avatar
            :display-avatar="displayAvatar"
            :image="item.userImage"
            :title="item.userDisplayName"
          />
        </md-table-cell>

        <md-table-cell
          md-label="Distanz"
          md-sort-by="result.distance"
          style="width: 35%"
        >
          {{
            item.result.distance ? formatM2Km(item.result.distance) : ''
          }}
        </md-table-cell>
        <md-table-cell
          md-label="Zeit"
          md-sort-by="result.time"
          style="width: 20%"
        >
          {{
            formatTimeWithSeconds(item.result.time) || "-"
          }}
        </md-table-cell>
      </md-table-row>
    </md-table>
    <div class="md-layout md-alignment-center-space-between">
      <pagination
        v-model="currentPage"
        class="pagination-no-border pagination-danger md-layout-item"
        :per-page="paginationPerPage"
        :total="pTotal"
      />
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import datetime from "../../utils/datetime.js";
import UserAvatar from "../atoms/user-avatar.vue";

export default {
  name: "ChallengeResultsTable",
  components: {
    Pagination,
    UserAvatar
  },
  props: {
    challenge: {
      type: Object
    },
    data: {
      type: Array,
      required: true
    },
    displayCrown: {
      type: Boolean,
      default: false
    },
    displayAvatar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchQuery: "",
      paginationPerPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      pTotal: 1,
    }
  },
  watch: {
    paginationPerPage(v) {
      this.$emit("reloadData", { paginationPerPage: this.paginationPerPage, currentPage: this.currentPage, pTotal: this.pTotal, searchQuery: this.searchQuery });
    },
    searchQuery(val) {
      this.$emit("reloadData", { paginationPerPage: this.paginationPerPage, currentPage: this.currentPage, pTotal: this.pTotal, searchQuery: val });
    }
  },
  methods: {
    ...datetime,
    getCrownImage(rank) {
      switch (rank) {
        case 1:
          return 'img/golden-crown.svg';
        case 2:
          return 'img/silver-crown.svg';
        case 3:
          return 'img/bronze-crown.svg';
        default:
          return '';
      }
    }
  }

}
</script>

<style lang="scss">
.challenge-results thead tr {
  background: #B3CCF8;
}
.challenge-results {
  .md-table-cell-container {
    display: flex;
    justify-content: flex-end !important;
    margin-left: 10px;
  }
  .md-table-head:last-child {
    text-align: left !important;
  }
  .pagination {
    width: 25% !important;
  }
  .search {
    width: 70% !important;
    display: flex;
    align-items: center;
    .md-icon {
      color: #AA9E9E !important;
    }
  }
}
.md-numeric {
  width: 10px;
}
.md-table-head-label {
  font-weight: 500;
}
.paginated-table{
  .md-table-toolbar{
    margin-bottom: 18px;
  }
}
</style>
